import cn from 'classnames';
/* Class assignment */
export var setGridClass = function (className) { return cn(className); };
export var tableClass = cn('my-0 mx-auto border-collapse');
export var cellClass = function (isHover) {
    return cn('transform transition-colors duration-100 ease-in', 'border-4 border-basic-black', 'cursor-pointer', 'hover:bg-secondary-400', !isHover && 'bg-gray-600', isHover && 'bg-secondary-400');
};
